import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 text-left" }
const _hoisted_6 = { class: "text-sm uppercase" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "mt-6 pb-2 text-left" }
const _hoisted_10 = { class: "text-sm uppercase" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFilterDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "filter"],
  setup(__props, { emit }) {

const props = __props

const selectedType = ref({ label: "-Select Type-", value: null });

let eventType = [
  {
    label: "-Select Type-",
    value: null,
  },
  {
    label: "DAILY",
    value: "DAILY",
  },
  {
    label: "WEEKLY",
    value: "WEEKLY",
  },
  {
    label: "CUSTOM",
    value: "CUSTOM",
  },
];

const onTypeSelected = (e: any) => {
  // console.log("onTypeSelected : ",e.target)
  selectedType.value = e.target;
  emit("update:form", { ...props.form, type: e.target.value });
};

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const onFilter = () => {
  emit("filter");
  showSync.value = false;
};

const onClose = () => {
  selectedType.value = { label: "-Select Type-", value: null };
  showSync.value = false;
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.advanceFilter")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.event.name")), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((__props.form as any).name) = $event)),
                              placeholder: _ctx.$t('messages.event.name')
                            }, null, 8, _hoisted_8), [
                              [_vModelText, (__props.form as any).name]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("messages.event.type")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "eventType",
                            name: "eventType",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedType.value.value) = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (onTypeSelected($event))),
                            class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventType), (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.value,
                                value: item.value
                              }, _toDisplayString(item.label), 9, _hoisted_11))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, selectedType.value.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, " close "),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (onFilter())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, " filter ")
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})